import { getAPIBaseURL } from './helpers'
import { getData, postData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

const getAuthHeaders = () => {
  const token = localStorage.getItem('token')
  return token ? { 'token': token } : {}
}

export const getWalletBalance = async () => {
  const url = `${base()}/wallet/balance`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const getWalletTransactions = async (params = {}) => {
  const url = `${base()}/wallet/transactions`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const getWalletTransaction = async (transactionId) => {
  const url = `${base()}/wallet/transactions/${transactionId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const listAdminPayouts = async (params = {}) => {
  const url = `${base()}/admin/payouts`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const getAdminPayoutById = async (payoutId) => {
  const url = `${base()}/admin/payouts/${payoutId}`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message || 'Failed to fetch payout' }
}

export const approvePayout = async (payoutId) => {
  const url = `${base()}/payouts/${payoutId}/approve`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded', ...getAuthHeaders() }
  const res = await postData(url, headers, '')
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const rejectPayout = async (payoutId, rejectionReason = '') => {
  const url = `${base()}/payouts/${payoutId}/reject`
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded', ...getAuthHeaders() }
  const params = new URLSearchParams()
  if (rejectionReason) params.append('rejectionReason', rejectionReason)
  const res = await postData(url, headers, params.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data?.data || res.result?.data?.message }
}

export const listAdminTransactions = async (params = {}) => {
  const url = `${base()}/admin/transactions`
  const headers = getAuthHeaders()
  const res = await getData(url, headers, params)
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

